import { FC } from 'react';

import { t } from 'i18next';
import { NavLink } from 'react-router-dom';

import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

export type MenuItemProps = {
  title: string;
  path: string;
  icon: string;
  tracking: {
    event_id: string;
    event_categorie: string;
    event_metier: string;
    event_nom: string;
    event_detail_1: string;
  };
  onClick: () => void;
};

export const MenuItem: FC<MenuItemProps> = ({ title, path, icon, tracking, onClick }) => {
  return (
    <NavLink
      to={path}
      className={({ isActive }) => (isActive ? styles.menuItemActive : styles.menuItem)}
      onClick={() => {
        void TRACKING_INSTANCE.triggerEvent('clic', undefined, tracking);
        onClick?.();
      }}
    >
      <i className={`totem-icon totem-icon-${icon}`} />
      <span className={styles.titleItem}>{t(title)}</span>
    </NavLink>
  );
};
